import {NavigateOptions, useNavigate, useSearchParams} from 'react-router';
import {CryptoCurrencyType} from '~/entities/currencies';

export function createTrTxReceiveRoute<CT extends CryptoCurrencyType, ID extends string | number>(
    currencyType: CT,
    id: ID,
    status?: string
) {
    if (status) {
        return `/operation/travel-rule-receive/${currencyType}/${id}/?${txStatusParam}=${status}` as const;
    } else {
        return `/operation/travel-rule-receive/${currencyType}/${id}/` as const;
    }
}

export function createTrTxSendRoute<CT extends CryptoCurrencyType, ID extends string | number>(
    currencyType: CT,
    id: ID,
    status?: string
) {
    if (status) {
        return `/operation/travel-rule-send/${currencyType}/${id}/?${txStatusParam}=${status}` as const;
    } else {
        return `/operation/travel-rule-send/${currencyType}/${id}/` as const;
    }
}

export function useTxStatusSearchParam() {
    const [search] = useSearchParams();
    return search.get(txStatusParam);
}

const txStatusParam = 'tx-status';

export type ParamKey = (typeof ParamKey)[keyof typeof ParamKey];
export const ParamKey = {
    step: 'step',
    dialog: 'dialog',
} as const;

export function useGoHome(options?: NavigateOptions) {
    const navigate = useNavigate();
    const goHome = () => {
        navigate('/', options);
    };
    return goHome;
}
export function useGoToSupport(options?: NavigateOptions) {
    const navigate = useNavigate();
    const goToSupport = () => {
        navigate('/support/form', options);
    };
    return goToSupport;
}
